import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { GoogleMapsApiKeyProvider } from './api/gis';
import { GeoCMSApiKeyProvider } from './api/geocms';
import './main.css';
import { GEOCMS_API } from './utils/Constants';
import { TCEventProvider } from './utils/TCEvent';
import { DeviceDetectionProvider } from './utils/DeviceDetection';
import { InputParamsProvider } from './utils/InputParamsProvider';
import { setFromPortletConfiguration, GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_CLIENT_ID } from './api/portletConfiguration';

export default function AXAMapApplication() {
	return (
		<InputParamsProvider>
			<DeviceDetectionProvider>
				<TCEventProvider>
					<GoogleMapsApiKeyProvider
						apiKey={GOOGLE_MAPS_API_KEY}
						client={GOOGLE_MAPS_CLIENT_ID}
						libraries="places"
					>
						<GeoCMSApiKeyProvider {...GEOCMS_API}>
							<App />
						</GeoCMSApiKeyProvider>
					</GoogleMapsApiKeyProvider>
				</TCEventProvider>
			</DeviceDetectionProvider>
		</InputParamsProvider>
	);
}

const MODE_PRODUCTION = process.env.NODE_ENV === 'production';

window.AxaLocator = {
	async setup(element, config) {
		setFromPortletConfiguration(config);
		function renderApp(AppComponent) {
			ReactDOM.render(<AppComponent />, element);
		}

		renderApp(AXAMapApplication);
	}
};

if (!MODE_PRODUCTION) {
	window.AxaLocator.setup(document.getElementById('root'));
}
